module.exports = __webpack_public_path__ + "static/img/yytx25.056f8e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx25.png
// module id = 894
// module chunks = 0